import React, { useRef, useState } from "react";
import Email from "../Icons/Email";
import { useLocation } from "react-router-dom";
import Spinner from "../misc/spinner";
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';

const ContactFrom = (props) => {
  let location = useLocation();
  const [cadidateDetails, setCadidateDetails] = useState({ first_name: "", last_name: "", email: "", job_title:"", technical_skills: "", linkedin_profile: "", number_of_relevant_experience: "", location: "", valid_visa: null});
  const [errors, setErrors] = useState({
    isfirst_nameError: false,
    islast_nameError: false,
    isEmailError: false,
    isFileError:false,
    isjob_titleError: false,
    istechnical_skillsError: false,
    islinkedin_profileError: false,
    isnumber_of_relevant_experienceError: false,
    isLocationError: false,
    isvalid_visaError: false,
    isAgreementError: false
  });

  const [selectedFile, setSelectedFile] = useState("");
  const [invalidFile, setInvalidFile] = useState("CV required");
  const [invalidEmail, setInvalidEmail] = useState("Email is required");
  const [showSpinner, setShowSpinner] = useState(false);
  const [agreement, setAgreement] = useState(false);
  const [fileContent, setFileContent] = useState({file_name:"",cv_file_content:""});

    
  const validateEmail = (email) => {
    const re =
      // eslint-disable-next-line
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const fileInput = useRef(null);
  const maxfilesize = (1024 * 1024) * 5;

  const handleFileChange = (event) => {
    if(event.target.files.length > 0){
      setSelectedFile(event.target.files[0]);
      const files = event.target.files[0];
      console.log(files.type);
      if (files.type !== "application/pdf" && files.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        errors.isFileError = true;
        setInvalidFile("Allow only PDF, .doc, and .docx files");
      } else {
        if (files.size > maxfilesize) {
          errors.isFileError = true;
          setInvalidFile("File size exceeds 5 MB");
        } else {
          errors.isFileError = false;
          const file = event.target.files[0]; // Corrected variable name from 'files' to 'event.target.files'
          convertToBase64(file);
        }
      }
       
    }
    event.target.value = null;
  };

  const convertToBase64 = (file) => {
      const reader = new FileReader();
      reader.onload = (event) => {
          const base64String = event.target?.result;
          const jsonPayload = JSON.stringify({
              file_name: file.name,
              cv_file_content: base64String.replace(/^data:.+;base64,/, '')
          });
          setFileContent(jsonPayload);
      };

      reader.readAsDataURL(file);
  };

  const isValidURL = (str) => {
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlRegex.test(str);
  }


  const saveUserData = (e) => {
    e.preventDefault();
    
    let hasError = false;
    let newErrors = { ...errors };

    if (cadidateDetails.first_name === "") {
      newErrors.isfirst_nameError = true;
      hasError = true;
    } else {
      newErrors.isfirst_nameError = false;
    }

    if (cadidateDetails.last_name === "") {
      newErrors.islast_nameError = true;
      hasError = true;
    } else {
      newErrors.islast_nameError = false;
    }

    if (cadidateDetails.email === "") {
      newErrors.isEmailError = true;
      setInvalidEmail("Email required");
      hasError = true;
    } else {
      if (!validateEmail(cadidateDetails.email)) {
        newErrors.isEmailError = true;
        setInvalidEmail("Invalid Email");
        hasError = true;
      } else {
        newErrors.isEmailError = false;
      }
    }

    if (selectedFile === "") {
      newErrors.isFileError = true;
      hasError = true;
    }else {
      newErrors.isFileError = false;
    }

    if (cadidateDetails.job_title === "") {
      newErrors.isjob_titleError = true;
      hasError = true;
    } else {
      newErrors.isjob_titleError = false;
    }

    if (cadidateDetails.number_of_relevant_experience === "") {
      newErrors.isnumber_of_relevant_experienceError = true;
      hasError = true;
    } else {
      newErrors.isnumber_of_relevant_experienceError = false;
    }

    if (cadidateDetails.technical_skills === "") {
      newErrors.istechnical_skillsError = true;
      hasError = true;
    } else {
      newErrors.istechnical_skillsError = false;
    }

    if (cadidateDetails.linkedin_profile !== ""){
      if(!isValidURL(cadidateDetails.linkedin_profile)){
        newErrors.islinkedin_profileError = true;
        hasError = true;
      }else{
        newErrors.islinkedin_profileError = false;
      }
    }
    else{
      newErrors.islinkedin_profileError = false;
    }

    if (cadidateDetails.valid_visa === null) {
      newErrors.isvalid_visaError = true;
      hasError = true;
    } else {
      newErrors.isvalid_visaError = false;
    }

    if (cadidateDetails.location === "") {
      newErrors.isLocationError = true;
      hasError = true;
    } else {
      newErrors.isLocationError = false;
    }

    if (!agreement) {
      newErrors.isAgreementError = true;
      hasError = true;
    } else {
      newErrors.isAgreementError = false;
    }

    setErrors(newErrors);  
    if (hasError) {
      return;
    }
    const fileContentObject = JSON.parse(fileContent);
    
    
    let data = { ...cadidateDetails };
    data.number_of_relevant_experience = data.number_of_relevant_experience + " years"
    data.file_name = fileContentObject.file_name;
    data.cv_file_content = fileContentObject.cv_file_content;
    

    setShowSpinner(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: "follow"
    };
    fetch(`
    https://prod-199.westeurope.logic.azure.com/workflows/a6445508aaf542bb940d2d0d3b97ab3a/triggers/manual/paths/invoke/uploadCV/ca1e433d-b67a-48b5-9949-ca4b94ce6159?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=WJ24-8RqRyGVpu9txKLK-k7XOtarHfkBRRJRnCcplHQ`
    , requestOptions)
      .then((response) => {
        if (!response.ok || !response.body) {
          throw new Error(`API error - ${response.statusText}`)
        }
        
        toast.success("Your application was successfully submitted.", {
          position: "bottom-right"
        });        
        setAgreement(false)
        setSelectedFile("")
        setFileContent({file_name:"",cv_file_content:""})
        setCadidateDetails({ first_name: "", last_name: "", email: "", job_title:"", technical_skills: "", linkedin_profile: "", number_of_relevant_experience: "", location: "", valid_visa: null});
        setShowSpinner(false);
      })
      .then((result) => console.log(result))
      .catch((error) => {
        setShowSpinner(false);
        toast.error("There is some error.", {
          position: "bottom-right"
        });
      });
      };

  return (
    <>
      <form name="contactFrom" {...props}>
        <div className="py-10">
          <div className="grid md:grid-cols-2 grid-cols-1 gap-8">
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                First name <span className="text-red-900">*</span>
              </label>
              <input
                type="text"
                name="fName"
                value={cadidateDetails.first_name}
                onChange={(e) => {
                  setCadidateDetails({ ...cadidateDetails, first_name: e.target.value });
                  setErrors({ ...errors, isfirst_nameError: false });
                }}
                className={`input-field ${
                  errors.isfirst_nameError ? "is-invalid" : null
                }`}
              />
              {errors.isfirst_nameError ? (
                <span className="text-red-900 text-xs">
                  First name required
                </span>
              ) : null}
            </div>
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                Last name <span className="text-red-900">*</span>
              </label>
              <input
                type="text"
                name="lName"
                value={cadidateDetails.last_name}
                onChange={(e) => {
                  setCadidateDetails({ ...cadidateDetails, last_name: e.target.value });
                  setErrors({ ...errors, islast_nameError: false });
                }}
                className={`input-field ${
                  errors.islast_nameError ? "is-invalid" : null
                }`}
              />
              {errors.islast_nameError ? (
                <span className="text-red-900 text-xs">
                  Last name required
                </span>
              ) : null}
            </div>
          </div>
          <div className="grid md:grid-cols-1 grid-cols-1 gap-8">
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                Your email <span className="text-red-900">*</span>
              </label>
              <div className="relative">
                <span className="absolute top-2 left-2">
                  <Email className="text-lightGray-100" />
                </span>
                <input
                  type="text"
                  name="email"
                  className={`input-field-email  ${
                    errors.isEmailError ? "is-invalid" : null
                  }`}
                  value={cadidateDetails.email}
                  onChange={(e) => {
                    setCadidateDetails({ ...cadidateDetails, email: e.target.value });
                    setErrors({ ...errors, isEmailError: false });
                  }}
                />
                {errors.isEmailError ? (
                  <span className="text-red-900 text-xs">{invalidEmail}</span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-1 grid-cols-1 gap-8">
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                Attach CV <span className="text-red-900">*</span>
              </label>
              <div className="relative">
                  <input
                  type="file"
                  onChange={handleFileChange}
                  ref={fileInput}
                  accept="application/pdf"
                  className={`input-field absolute top-0 left-0 opacity-0 z-1 w-0 h-0`}
                />
                <div
                  className={`input-file-field input-field block px-3 flex flex-row justify-between relative z-50 opacity-100 items-center ${
                    errors.isFileError ? "is-invalid" : null
                  }`}
                  onClick={(e) => fileInput.current && fileInput.current.click()}
                >
                  <span className="text-13 font-avenirHeavy ">
                    {selectedFile.name}
                  </span>
                  <span className="browse-file bg-blue-500 rounded text-white text-sm py-2 px-5 font-normal font-avenirHeavy inline-block my-1">
                    Browse
                  </span>
                </div>
              </div>
              <span className="text-xs font-avenirBook text-blue-800 block">
                Only .pdf files are allowed. File size must be under 1MB.
              </span>
              {errors.isFileError ? (
                  <span className="text-red-900 text-xs">{invalidFile}</span>
                ) : null}
            </div>
          </div>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-8">
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                Job title<span className="text-red-900">*</span>
              </label>
              <input
                type="text"
                name="job_title"
                value={cadidateDetails.job_title}
                onChange={(e) => {
                  setCadidateDetails({ ...cadidateDetails, job_title: e.target.value });
                  setErrors({ ...errors, isjob_titleError: false });
                }}
                className={`input-field ${
                  errors.isjob_titleError ? "is-invalid" : null
                }`}
              />
              {errors.isjob_titleError ? (
                <span className="text-red-900 text-xs">
                  Job title required
                </span>
              ) : null}
            </div>
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                Years of relevant experience<span className="text-red-900">*</span>
              </label>
              <input
                type="number"
                name="number_of_relevant_experience"
                value={cadidateDetails.number_of_relevant_experience}
                onChange={(e) => {
                  setCadidateDetails({ ...cadidateDetails, number_of_relevant_experience: e.target.value });
                  setErrors({ ...errors, isnumber_of_relevant_experienceError: false });
                }}
                className={`input-field ${
                  errors.isnumber_of_relevant_experienceError ? "is-invalid" : null
                }`}
              />
              {errors.isnumber_of_relevant_experienceError ? (
                <span className="text-red-900 text-xs">
                  Years of experience required
                </span>
              ) : null}
            </div>
          </div>
          <div className="grid md:grid-cols-1 grid-cols-1 gap-8">
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                Technical Skills <span className="text-red-900">*</span>
              </label>
              <div className="relative">
              <input
                type="text"
                name="technical_skills"
                value={cadidateDetails.technical_skills}
                onChange={(e) => {
                  setCadidateDetails({ ...cadidateDetails, technical_skills: e.target.value });
                  setErrors({ ...errors, istechnical_skillsError: false });
                }}
                className={`input-field ${
                  errors.istechnical_skillsError ? "is-invalid" : null
                }`}
              />
              {errors.istechnical_skillsError ? (
                <span className="text-red-900 text-xs">
                  Technical skills required
                </span>
              ) : null}            
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-1 grid-cols-1 gap-8">
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                Linkedin Profile
              </label>
              <div className="relative">
              <input
                type="url"
                name="technical_skills"
                value={cadidateDetails.linkedin_profile}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const isValidUrl = inputValue === "" ? true: isValidURL(inputValue);
                  setCadidateDetails({ ...cadidateDetails, linkedin_profile: inputValue });
                  setErrors({ ...errors, islinkedin_profileError: !isValidUrl });
                }}
                className={`input-field ${
                  errors.islinkedin_profileError ? "is-invalid" : null
                }`}
              />
              {errors.islinkedin_profileError ? (
                <span className="text-red-900 text-xs">
                  Please enter a valid URL
                </span>
              ) : null}            
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-8">
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                Visa (would you require sponsorship?)<span className="text-red-900">*</span>
              </label>
              <div className="flex items-center">
                <input
                  type="radio"
                  id="Yes"
                  name="visa"
                  value="Yes"
                  checked={cadidateDetails.valid_visa === "Yes"}
                  onChange={(e) => {
                    setCadidateDetails({ ...cadidateDetails, valid_visa: "Yes" });
                    setErrors({ ...errors, isvalid_visaError: false });
                  }}
                  className={`mr-2 input-field ${
                    errors.isvalid_visaError ? "is-invalid" : null
                  }`}
                />
                <label htmlFor="Yes" className="mr-4 text-base font-opensans text-Gray-400 block">
                  Yes
                </label>
                <input
                  type="radio"
                  id="No"
                  name="visa"
                  value="No"
                  checked={cadidateDetails.valid_visa === "No"}
                  onChange={(e) => {
                    setCadidateDetails({ ...cadidateDetails, valid_visa: "No" });
                    setErrors({ ...errors, isvalid_visaError: false });
                  }}
                  className={`mr-2 input-field ${
                    errors.isvalid_visaError ? "is-invalid" : null
                  }`}
                />
                <label htmlFor="No" className="text-base font-opensans text-Gray-400 block">
                  No
                </label>                
              </div>
              {errors.isvalid_visaError ? (
                  <span className="text-red-900 text-xs">
                    Visa status required
                  </span>
                ) : null} 

            </div>
            <div className="mb-6">
              <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                Location<span className="text-red-900">*</span>
              </label>
              <input
                type="text"
                name="location"
                value={cadidateDetails.location}
                onChange={(e) => {
                  setCadidateDetails({ ...cadidateDetails, location: e.target.value });
                  setErrors({ ...errors, isLocationError: false });
                }}
                className={`input-field ${
                  errors.isLocationError ? "is-invalid" : null
                }`}
              />
              {errors.isLocationError ? (
                <span className="text-red-900 text-xs">
                  Location required
                </span>
              ) : null} 
            </div>
          </div>
          <div className="grid md:grid-cols-1 grid-cols-1 gap-8">
            <div className="mb-6 flex justify-between items-center">
              <div className="flex items-center block"> 
              <label htmlFor="agreementCheckbox" className="text-sm font-opensans text-Gray-400">
                <input
                  type="checkbox"
                  id="agreementCheckbox"
                  name="Agreement"
                  value={agreement}
                  checked={agreement === true}
                  onChange={(e) => {
                    setAgreement(e.target.checked);
                    setErrors({ ...errors, isAgreementError: false });
                  }}
                  className={`agreement-checkbox input-field ${errors.isAgreementError ? "is-invalid" : ""}`}
                />
                Agreement to temporarily store the data.<span className="text-red-900">*</span>
              </label>
              
              {errors.isAgreementError ? (
                <span className="text-red-900 text-xs">Agreement is required</span>
              ) : null}
              </div>
            </div>
          </div>
          <ToastContainer />      
          <div className="flex flex-row justify-end mt-5 button-row">
            <button
              type="submit"
              onClick={(e) => saveUserData(e)}
              className={`brand-primary-sm-btn`}
            >
              {location.pathname === "/career" ? "Register" : "Submit"}
            </button>
          </div>
        </div>
      </form>

      {showSpinner ? (
        <div className="fixed top-0 right-0 bottom-0 left-0 full-loader">
          <div className="flex flex-col items-center justify-center h-full">
            <Spinner />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ContactFrom;
